module.exports = __webpack_public_path__ + "static/media/reservation_type_event.3fe246d6.png";